import type { ReactNode } from 'react'
import { Select } from '@systemeio/components'
import { CheckIcon, ChevronDownIcon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next'
import { TemplatesCategoryInterface } from '../types/templates-category-interface'
import { TemplatesFilterInterface } from '../types/templates-filter-interface'

const TemplatesCategorySelector = ({
  categories,
  filter,
  onChangeCategory,
}: {
  categories: TemplatesCategoryInterface[]
  filter: TemplatesFilterInterface
  onChangeCategory: (category: number | null) => void
}): ReactNode => {
  const { t } = useTranslation()

  const allCategoriesLabel = t('public.templates.categories.all_categories')

  const options: Array<{ value: number | null; label: string }> = [
    { value: null, label: allCategoriesLabel },
    ...categories.map(category => ({ value: category.id, label: category.name })),
  ]
  const availableOptions = options.filter(option => option.value !== filter.category)

  const selectedCategory = categories.find(category => category.id === filter.category)
  const triggerLabel = selectedCategory?.name ?? allCategoriesLabel

  return (
    <div className="flex lg:hidden">
      <Select.Root<number | null>
        items={options}
        value={filter.category}
        onValueChange={onChangeCategory}
      >
        <Select.Trigger size="md" className="w-full" aria-label={triggerLabel}>
          <Select.Value placeholder={allCategoriesLabel} />
          <Select.Icon>
            <ChevronDownIcon aria-hidden="true" className="size-5" />
          </Select.Icon>
        </Select.Trigger>
        <Select.Content>
          <Select.List>
            {availableOptions.map(option => (
              <Select.Item key={option.value ?? 'all'} value={option.value}>
                <Select.ItemIndicator>
                  <CheckIcon className="size-5" aria-hidden="true" />
                </Select.ItemIndicator>
                <Select.ItemText>{option.label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.List>
        </Select.Content>
      </Select.Root>
    </div>
  )
}

export default TemplatesCategorySelector
